export default function getTotalTicketQuantity(selectedTicketTypes) {
  return selectedTicketTypes.reduce((total, ticket) => {
    return total + ticket.quantity;
  }, 0);
}
